module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ABR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Australian Biblical Review")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ACCS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ancient Christian Commentary on Scripture")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AcT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Acta Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AIL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ancient Israel and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANET")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". Edited by J. B. Pritchard. 3rd ed. Princeton: Princeton University Press, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AOTC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Abingdon Old Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aq")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aquila’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(", 2 vols. (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ArBib")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Aramaic Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aramaic Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Assyriological Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("b.")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(followed by the name of a tractate) Babylonian Talmud")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BASOR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDB")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown, F., S. R. Driver, and C. A. Briggs. "), _c('em', [_vm._v("A Hebrew and English Lexicon of the Old Testament")]), _vm._v(". Reprinted with corrections. Oxford: Clarendon, 1968")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BEATAJ")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beiträge zur Erforschung des Alten Testaments und des antiken Judentum")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BEHER")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibliothèque de l’École des hautes études: Sciences religieuses")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BETL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibliotheca Ephemeridum Theologicarum Lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica Stuttgartensia.")]), _vm._v(" Edited by K. Elliger and W. Rudolph. Stuttgart: Deutsche Bibelgesellschaft, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHQ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica Quinta")]), _vm._v(". Edited by A. Schenker et al. Stuttgart: Deutsche Bibelgesellschaft, 2004–")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibInt")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BibInt")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Interpretation Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BibOr")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblica et Orientalia")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BibSem")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Biblical Seminar")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BKAT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblischer Kommentar, Altes Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BW")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bible and Women")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BZ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CHANE")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Culture and History of the Ancient Near East")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("COS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Context of Scripture")]), _vm._v(". Edited by W. W. Hallo. 3 vols. Leiden: Brill, 1997–2002")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTAT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Critique Textuelle de l’Ancien Testament")]), _vm._v(". By D. Barthélemy. Vol. 2"), _c('em', [_vm._v(".")]), _vm._v(" Göttingen: Vandenhoeck, 1986")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTQ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Concordia Theological Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CurTM")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Theology and Mission")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DCH")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Classical Hebrew")]), _vm._v(". Edited by D. J. A. Clines. 9 vols. Vols. 1–5, Sheffield: Sheffield Academic, 1993–2001; vols. 6–9: Sheffield: Sheffield Phoenix, 2007–2016")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DG")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Davidson’s Introductory Hebrew Grammar: Syntax.")]), _vm._v(" Ed. J. C. L. Gibson. Edinburgh: T&T Clark, 1994")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DJD")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Discoveries in the Judaean Desert")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DSS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Dead Sea Scrolls")]), _vm._v(". Edited by F. García Martínez and E. J. C. Tigchelaar. 2 vols. Repr., Leiden: Brill, 2000")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DTT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Dictionary of the Targumim, the Talmud Babli and Yerushalmi, and the Midrashic Literature.")]), _vm._v(" By M. Jastrow. New York: Choreb, 1926")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ExAud")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ex Auditu")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FAT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FOTL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forms of the Old Testament Literature")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GK")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(". Edited by E. Kautzsch. Translated by A. E. Cowley. 2nd ed. Oxford: Clarendon, 1910")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GPBS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Global Perspectives on Biblical Scholarship")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HALOT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament")]), _vm._v(". L. Koehler, W. Baumgartner, and J. J. Stamm. Translated and edited under the supervision of M. E. J. Richardson. 4 vols. Leiden: Brill, 1994–1999")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HAR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Annual Review")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HBM")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hebrew Bible Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HBT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Horizons in Biblical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HCOT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Historical Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HThKAT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herders Theologischer Kommentar zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HTR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Harvard Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HvTSt")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hervormde teologiese studies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("IBC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Interpretation: A Bible Commentary for Teaching and Preaching")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IBHS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("An Introduction to Biblical Hebrew Syntax")]), _vm._v(". B. K. Waltke and M. O’Connor. Winona Lake, IN: Eisenbrauns, 1990")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IBS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Irish Biblical Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ICC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IDS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("In die Skriflig")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ITC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Theological Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JANESCU")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Ancient Near Eastern Society of Columbia University")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JAOS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the American Oriental Society")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JCS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Cuneiform Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JHebS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Hebrew Scriptures")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JM")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joüon, P. "), _c('em', [_vm._v("A Grammar of Biblical Hebrew")]), _vm._v(". Translated and revised by T. Muraoka. 2 vols. Rome: Pontifical Biblical Institute, 1991")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JNSL")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Northwest Semitic Languages")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Religion")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LamR")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lamentations Rabbah, as translated in H. Freedman and M. Simon, eds., “Lamentations Rabbah,” in "), _c('em', [_vm._v("Midrash Rabbah")]), _vm._v(", vol. 4. (London: Soncino, 1977)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LHBOTS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Library of the Hebrew Bible/Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Septuaginta: Id est Vestus Testamentum graece iuxta LXX interpretes")]), _vm._v(". Edited by A. Rahlfs and R. Hanhart. Rev. ed. Stuttgart: Deutsche Bibelgesellschaft, 2006")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mesopotamian Civilizations")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MG")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Mikraot Gedolot (the “Rabbinic Bible”), as published in A. J. Rosenberg, "), _c('em', [_vm._v("The Books of Lamentations, Ecclesiastes")]), _vm._v(", vol. 2 of "), _c('em', [_vm._v("The Five Megilloth")]), _vm._v(" (New York: Judaica, 1992)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masoretic Text; MT"), _c('span', {
    staticClass: "super"
  }, [_vm._v("A")]), _vm._v(" refers to the Aleppo Codex, MT"), _c('span', {
    staticClass: "super"
  }, [_vm._v("L")]), _vm._v(" to the Leningrad Codex")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NCB")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Century Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIB")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The New Interpreter’s Bible. Edited by L. E. Keck. 12 vols. Nashville: Abingdon, 1994–2004")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIBCOT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Biblical Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Or")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Orientalia")]), _vm._v(" (NS)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OTE")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Old Testament Essays")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PG")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Graeca [= Patrologiae Cursus Completus: Series Graeca]. Edited by J.-P. Migne. 162 vols. Paris, 1857–1886")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Latina [= Patrologiae Cursus Completus: Series Latina]. Edited by J.-P. Migne. 217 vols. Paris, 1844–1864")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4QLam")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Manuscript fragments of Lamentations from Qumran Cave 4; see F. M. Cross, “4QLam,” in E. C. Ulrich et al., "), _c('em', [_vm._v("Qumran Cave 4.XI: Psalms to Chronicles")]), _vm._v(", DJD 16 (Oxford: Clarendon, 2000), 229–37")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("5QLam")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Manuscript fragment of Lamentations from Qumran Cave 5; see J. T. Milik, “Lamentations,” in "), _c('em', [_vm._v("Les “Petites Grottes” de Qumrân: Exploration de la Falaise: Les grottes 2Q, 3Q, 5Q, 6Q, 7Q à 10Q, le rouleau de cuivre")]), _vm._v(", ed. M. Baillet, J. T. Milik, and R. de Vaux, DJD 3 (Oxford: Clarendon, 1962), 174–78")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RB")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Revue biblique")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ResQ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Restoration Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevExp")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Review and Expositor")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RTR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Reformed Theological Review")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLStBL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Studies in Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SemeiaSt")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Semeia Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJOT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scandinavian Journal of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SSN")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia Semitica Neerlandica")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sym")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symmachus’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(", 2 vols. (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SymS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symposium Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Syr")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Syriac translation of the Old Testament, as printed in D. M. Walter, G. Greenberg, G. A. Kiraz, and J. Bali, eds., "), _c('em', [_vm._v("The Syriac Peshi"), _c('span', {
    staticClass: "font2"
  }, [_vm._v("ṭ")]), _vm._v("ta Bible with English Translation: Lamentations, Prayer of Jeremiah, Epistle of Jeremiah and Epistles of Baruch")]), _vm._v(" (Piscataway, NJ: Gorgias, 2013)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDOT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(". Volumes 1–8 edited by G. J. Botterweck and H. Ringgren. Volumes 9–15 and volume 17 edited by G. J. Botterweck, Helmer Ringgren, and Heinz-Josef Fabry. Volume 16 edited by Holger Gzella. Translated by J. T. Willis et al. 17 vols. Grand Rapids: Eerdmans, 1974–2021")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tg")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Targum, as printed in A. Sperber, "), _c('em', [_vm._v("The Hagiographa")]), _vm._v(", vol. 4a of "), _c('em', [_vm._v("The Bible in Aramaic")]), _vm._v(" (Leiden: Brill, 1968)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theod")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theodotion’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(", 2 vols. (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TOTC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tyndale Old Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TTH")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Treatise on the Use of the Tenses in Hebrew")]), _vm._v(". By S. R. Driver. 3rd ed. Oxford: Clarendon, 1892")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TThSt")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Trierer theologische Studien")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TynB")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vg")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vulgate Latin translation, as printed in R. Weber, ed., "), _c('em', [_vm._v("Biblia Sacra Iuxta Vulgatam Versionem")]), _vm._v(" (Stuttgart: Deutsche Bibelgesellschaft, 1969)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("YNER")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Yale Near Eastern Researches")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eb77c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbre.vue
// module id = 75
// module chunks = 0